module.exports = __webpack_public_path__ + "img/PAI_Landing-Page_Desktop_25.c41dc67b.jpg";